// src/components/Footer.jsx
import React from 'react';
import {
  Box,
  Container,
  Grid,
  Stack,
  Typography,
  Link as MuiLink,
  IconButton,
  Divider
} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const Footer = () => {
  return (
    <Box component="footer" sx={{ bgcolor: '#171a21', color: 'rgba(255,255,255,0.88)', mt: 0 }}>
      <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
        <Grid container spacing={6}>
          {/* Corporate */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ color: '#fff', mb: 2, fontWeight: 700 }}>
              Corporate
            </Typography>

            <Stack spacing={1.2}>
              <Typography variant="body1">
                14701 Philips Highway, Suite 202
              </Typography>
              <Typography variant="body1">
                Jacksonville, FL 32256
              </Typography>
              <MuiLink
                href="tel:18332707191"
                underline="none"
                sx={{ color: 'rgba(255,255,255,0.88)', '&:hover': { color: '#fff' } }}
              >
                833-270-7191
              </MuiLink>
            </Stack>
          </Grid>

          {/* Legal */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ color: '#fff', mb: 2, fontWeight: 700 }}>
              Legal
            </Typography>

            <Stack spacing={1.2}>
              <MuiLink href="/privacy" underline="none" sx={{ color: 'inherit', '&:hover': { color: '#fff' } }}>
                Privacy Policy
              </MuiLink>
              <MuiLink href="/licensing" underline="none" sx={{ color: 'inherit', '&:hover': { color: '#fff' } }}>
                Legal &amp; Licensing
              </MuiLink>
               <MuiLink href="/ccpa" underline="none" sx={{ color: 'inherit', '&:hover': { color: '#fff' } }}>
      CCPA
    </MuiLink>
              <MuiLink href="/security" underline="none" sx={{ color: 'inherit', '&:hover': { color: '#fff' } }}>
                Security Statement
              </MuiLink>
              <MuiLink href="/terms" underline="none" sx={{ color: 'inherit', '&:hover': { color: '#fff' } }}>
                Terms of Use
              </MuiLink>
              <MuiLink href="/data-partners" underline="none" sx={{ color: 'inherit', '&:hover': { color: '#fff' } }}>
                Data Partners
              </MuiLink>
              <MuiLink href="/business-profiles" underline="none" sx={{ color: 'inherit', '&:hover': { color: '#fff' } }}>
                Business Profiles
              </MuiLink>
            </Stack>
          </Grid>

          {/* Social / Badges */}
          <Grid item xs={12} md={4}>
            <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
              <IconButton
                aria-label="Facebook"
                component="a"
                href="https://facebook.com/JetHomeLoans"
                target="_blank"
                rel="noopener"
                sx={{ color: 'rgba(255,255,255,0.88)' }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                aria-label="Instagram"
                component="a"
                href="https://www.instagram.com/jethomeloans/"
                target="_blank"
                rel="noopener"
                sx={{ color: 'rgba(255,255,255,0.88)' }}
              >
                <InstagramIcon />
              </IconButton>
              <IconButton
                aria-label="X"
                component="a"
                href="https://x.com/JetHomeLoans"
                target="_blank"
                rel="noopener"
                sx={{
                  color: 'rgba(255,255,255,0.88)',
                  width: 40,
                  height: 40,
                }}
              >
                <Box
                  component="img"
                  src="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1763050149/X_Social_Media_Icon_niizkk.png"
                  alt="X (formerly Twitter)"
                  sx={{ width: 22, height: 22, objectFit: 'contain' }}
                />
              </IconButton>
              <IconButton
                aria-label="LinkedIn"
                component="a"
                href="https://www.linkedin.com/company/jet-homeloans/"
                target="_blank"
                rel="noopener"
                sx={{ color: 'rgba(255,255,255,0.88)' }}
              >
                <LinkedInIcon />
              </IconButton>
            </Stack>

            {/* BBB link text */}
            <Typography variant="body2" sx={{ mb: 1.5 }}>
              <MuiLink
                href="https://www.bbb.org/us/fl/jacksonville/profile/loans/jet-homeloans-lp-0403-235999224"
                target="_blank"
                rel="noopener"
                underline="none"
                sx={{ color: 'inherit', '&:hover': { color: '#fff' } }}
              >
                Click for the BBB Business Review of this Mortgage Brokers in Florida
              </MuiLink>
            </Typography>

            {/* Equal Housing Lender badge linked to BBB */}
            <Box
              component={MuiLink}
              href="https://www.bbb.org/us/fl/jacksonville/profile/loans/jet-homeloans-lp-0403-235999224"
              target="_blank"
              rel="noopener"
              underline="none"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                mb: 1.5,
                color: 'inherit',
                '&:hover': { color: '#fff' },
              }}
            >
              <Box
                component="img"
                src="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1759252835/blue-seal-96-50-fbcmortgagellc-151631617_ypyrg9.png"
                alt="Equal Housing Lender"
                sx={{ width: 104, height: 64, objectFit: 'contain' }}
              />
               {/* Equal Housing Lender Logo — NEW */}
  <Box
    component="img"
    src="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1763498027/Logo_-_Equal_Housing_Lender_white_rkqsol.png"
    alt="Equal Housing Lender Icon"
    sx={{ width: 44, height: 44, objectFit: 'contain' }}
  />
              <Typography variant="body2">Equal Housing Lender</Typography>
            </Box>

            <Typography variant="body2" sx={{ mb: 0.5 }}>
              For licensing information, go to
            </Typography>
            <MuiLink
              href="https://www.nmlsconsumeraccess.org"
              target="_blank"
              rel="noopener"
              underline="none"
              sx={{ color: 'inherit', '&:hover': { color: '#fff' } }}
            >
              www.nmlsconsumeraccess.org
            </MuiLink>
          </Grid>
        </Grid>
      </Container>

      <Divider sx={{ borderColor: 'rgba(255,255,255,0.12)' }} />

      <Container maxWidth="lg">
        <Typography
          variant="caption"
          sx={{
            display: 'block',
            py: 3,
            color: 'rgba(255,255,255,0.78)',
            lineHeight: 1.6,
          }}
        >
          ©Jet HomeLoans, LP SM (“Jet”) NMLS ID# 1660135. Equal Housing Lender. All products are subject to credit and property approval. Programs, rates, program terms and conditions subject to change without notice. Not all products are available in all states or for all amounts. Other restrictions and limitations apply. This is not a commitment to lend.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
